import { Image, ImageProps } from 'expo-image';
import React from 'react';

const LocalImage: React.FC<ImageProps> = props => <Image {...props} />;

export default LocalImage;
